import React, { createContext, useState, useEffect } from "react";
import axiosMain from "../InsocialOrbit/http/axiosMain";
import { toast, ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import { Navigate, useNavigate } from "react-router-dom";

// Create the context
export const GlobalContext = createContext();

// Create the GlobalProvider component
export const GlobalProvider = ({ children }) => {
  const [authToken, setAuthToken] = useState(null);
  const [userData, setUserData] = useState(null);
  const [isLogdin, setisLogdin] = useState(false);
  const [loading, setLoading] = useState(false); // Loader state
  const [requestId, setRequestId] = useState(null); // Send contract na page ma joye barobar kadhata nai.
    const [no_of_influencer_viewed, setNoOfInfluencerViewed] = useState(0);
  const [no_of_influencer_allowed, setNoOfInfluencerAllowed] = useState(5);
  const [walletBalance, setWalletBalance] = useState(0);


  const navigate = useNavigate();

  // wallet balance
    useEffect(() => {
      const fetchWalletBalance = async () => {
        try {
          const response = await axiosMain.get("/api/user/wallet/balance");
          // console.log("Wallet API Response:", response.data);
          setWalletBalance(response?.data?.data?.balance || 0); // adjust if API returns different structure, fallback to 0
          // console.log("Wallet API Response:", response.data.balance);
        } catch (error) {
          console.error("Failed to fetch wallet balance", error);
          setWalletBalance(0); // Ensure fallback to 0 on error
        }
      };
  
      fetchWalletBalance();
    }, []);

  useEffect(() => {
    //const token = localStorage.getItem("authToken");
    // if (token) {
    axiosMain
      .get("/api/v1/me")
      .then((res) => {
        if (res.status === 200) {
          setisLogdin(res.data.isUserLoggedIn);
          setUserData(res.data.user);
          localStorage.setItem("isAdminAddprofile",res?.data?.user?.source)
          const brandName = res.data?.user?.brand_name; // Optional chaining to prevent errors

          // Storing in localStorage if brandName exists
          if (brandName) {
            localStorage.setItem("brandName", brandName);
          } else {
            console.log("No brand name found in the response.");
          }

          // setAuthToken(token); // Restore token if it's saved in localStorage
        } else {
          navigate("/");
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          navigate("/");
          console.error("please login");
        } else {
          console.error("please login");
        }
        // console.log("Error:", err);
        // console.log("Error:", err);
      });
    // }
    // Optionally, you can load user data here from localStorage or an API if you store it
  }, []);

  // Function to login (set auth token and store in localStorage)
  const login = (token, userData) => {
    localStorage.setItem("authToken", token); // Store the token in localStorage
    setAuthToken(token); // Set auth token in state
    setUserData(userData); // Store user data (if you want to use it globally)
  };

  // Function to logout (remove auth token and user data)
  const logout = () => {
    localStorage.removeItem("authToken");
    setAuthToken(null); // Clear the token
    setUserData(null); // Clear user data
  };

  // Global state that can be accessed by any component
  return (
    <GlobalContext.Provider
      value={{
        authToken,
        userData,
        login,
        logout,
        isLogdin,
        setisLogdin,
        setUserData,
        requestId,
        setRequestId,
        no_of_influencer_viewed,
        setNoOfInfluencerViewed,
        no_of_influencer_allowed,
        setNoOfInfluencerAllowed,
        walletBalance,
        setWalletBalance,

      }}
    >
      {children}
      <ToastContainer position="top-right" autoClose={3000} />
    </GlobalContext.Provider>
  );
};